import { render } from "./KSReportTour.vue?vue&type=template&id=f4047d7a"
import script from "./KSReportTour.vue?vue&type=script&lang=js"
export * from "./KSReportTour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__